import React, { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Validator from 'devextreme-react/validator'
import { RequiredRule } from 'devextreme-react/form'
import SelectBox from 'devextreme-react/select-box'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'

const SelectBoxField = ({ question, options, submit }) => {
  const selectBox = useRef(null)
  const required = question.es_obligatoria
  const button = useRef(null)
  const isLargeScreen = useMediaQuery('(min-width: 640px)')
  const respuesta = question.respuesta_seleccion

  const submitCallback = useCallback(() => {
    submit(selectBox.current.instance.option('value'))
  }, [submit])

  useEffect(() => {
    const instance = selectBox.current.instance
    if (respuesta) return
    if (isLargeScreen) {
      instance.focus()
    }
    if (required) {
      setTimeout(() => instance.open(), 485)
    }
  }, [isLargeScreen, required, respuesta, selectBox])

  return (
    <>
      <SelectBox
        ref={selectBox} placeholder='Seleccione una opción'
        validationMessageMode='always'
        dataSource={options}
        displayExpr='nombre'
        valueExpr='id'
        onValueChanged={submitCallback}
        searchEnabled
        searchExpr={['nombre']}
        searchTimeout={0}
        defaultValue={respuesta}
      >
        <Validator onValidated={({ isValid }) => {
          const btn = button.current.instance.element()
          if (isValid) {
            btn.classList.remove('mt-8')
          } else {
            btn.classList.add('mt-8')
          }
        }}
        >
          {required ? <RequiredRule message='Este campo es requerido' /> : undefined}
        </Validator>
      </SelectBox>

      <Button
        ref={button}
        width={isLargeScreen ? 138 : '100%'}
        className='mt-5'
        icon='arrowright'
        type='success' style={{ backgroundColor: '#40c0c0' }}
        text='Continuar'
        onClick={submitCallback}
      />
    </>

  )
}

SelectBoxField.propTypes = {
  question: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  submit: PropTypes.func.isRequired
}

export default SelectBoxField
